// import './TokenNomic.scss'
export default function BotComp() {
  return (
    <div className="tokenNomicComp">
      <p className="title">A free <a style={{ color:'blueviolet' }} href="#/" target="_blank" rel="noopener noreferrer">telegram bot</a> to access defi candy modules. Current active modules:</p>
      <div className="list">
        <div className="listItem">
          <p className="num">1. </p>
          <div className="content">
            <p><b>Token Inspector</b></p>
            <p>Retrieve other tokens deployed by the creator and its related wallet</p>
          </div>
        </div>
        <div className="listItem">
          <p className="num">2. </p>
          <div className="content">
            <p><b>Volume Spike Detector</b></p>
            <p>Push notification on prominent spike transaction volume within short period. Data retrieved from Coinmarketcap</p>
          </div>
        </div>
        <div className="listItem">
          <p className="num">3. </p>
          <div className="content">
            <p><b>New Added Coins</b></p>
            <p>Check new added coins from Coinmarketcap and Coingecko</p>
          </div>
        </div>
        <div className="listItem">
          <p className="num">4. </p>
          <div className="content">
            <p><b>Trending Coins</b></p>
            <p>Check trending coins from Coinmarketcap and Coingecko</p>
          </div>
        </div>
        <p>More unexpectedly creative modules to come!</p>
      </div>
    </div>
  )
}
